import React from 'react';
import { Stagger, Item, ParallaxBlock } from './motion';

export const Mission = () => (
  <section id="misiune" className="section glow-copper">
    <div className="container">
      <ParallaxBlock distance={34} fade={false} scaleRange={[0.98, 1, 0.98]}>
        <Stagger>
          <Item as="p" className="mv-statement">
            Un cabinet nu ar trebui să-și petreacă ziua căutând un articol de lege, verificând
            manual portalul instanțelor sau completând sute de plicuri. <b>Software-ul poate face
            partea asta.</b>
          </Item>
        </Stagger>
      </ParallaxBlock>

      <Stagger className="mv-cols">
        <Item>
          <h3 className="mv-h">Misiunea noastră</h3>
          <p className="mv-p">
            Să eliminăm munca repetitivă din practica juridică. Construim aplicații care preiau
            exact partea mecanică a zilei de lucru — căutarea în legislație și jurisprudență,
            urmărirea termenelor, întocmirea corespondenței — și o livrează verificabilă, cu
            sursa la vedere.
          </p>
          <p className="mv-p">
            Nu vindem promisiuni despre inteligență artificială. Fiecare rezultat vine cu
            trimiterea la actul normativ, la dosarul de pe portal sau la documentul din care a
            fost extras, ca profesionistul să poată confirma în câteva secunde.
          </p>
        </Item>

        <Item>
          <h3 className="mv-h">Viziunea noastră</h3>
          <p className="mv-p">
            Un singur set de instrumente pentru toată munca de cabinet. Vedem un birou în care
            cercetarea, dosarele și corespondența nu mai sunt trei lumi separate: o sentință
            procesată într-o aplicație aduce termenele în calendarul celeilalte, iar un document
            expediat își ia singur numărul de ieșire.
          </p>
          <p className="mv-p">
            Mergem într-acolo pas cu pas, cu produse care funcționează bine și separat, dar care
            se leagă între ele — și care rămân accesibile inclusiv cabinetelor mici.
          </p>
        </Item>
      </Stagger>
    </div>
  </section>
);

export default Mission;
